export const LOOP_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}
export const CHROMLESS_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": false,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}

export const PLAYBACKRATES_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}

export const BACKGROUND_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "muted": true,
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": false,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}


export const DOWNLOAD_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        },
        "downloadOptions": {
            "link": "https://download.webtv-solution.com/NGRlNjhkYTc1/acme/2018-06-07T20:30/demo/empreinte-motion-vf-61a5gyue-43_94.mp4",
            "name": "Teasing_empreinte.com"
        }
    }
}

export const CAPTION_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [{
                "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/cc\/vtt\/fr\/94.vtt",
                "kind": "captions",
                "srclang": "fr",
                "label": "Fran\u00e7ais",
                "default": true
            }],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}


export const INFO_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        },
        "infoOptions": {
            "title": "Teasing empreinte.com",
            "image": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/mini\/cf1755458d37033d81799d089971d4dd.jpg",
            "list_lag": [],
            "duree": "00:01:10",
            "date": "2018-04-23",
            "description": "",
            "contributeur": "empadmin",
            "nb_views": 68
        }
    }
}

export const SETTING_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        },
        "infoOptions": {
            "title": "Teasing empreinte.com",
            "image": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/mini\/cf1755458d37033d81799d089971d4dd.jpg",
            "list_lag": [],
            "duree": "00:01:10",
            "date": "2018-04-23",
            "description": "",
            "contributeur": "empadmin",
            "nb_views": 68
        }
    }
}


export const SHARE_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        },
        "shareOptions": {
            "socials": ["fb", "tw", "linkedin", "gp"],
            "title": "Teasing empreinte.com",
            "description": "",
            "image": "https:\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
            "fbAppId": "1980855782163905",
            "hashtag": "#Teasing_empreinte.com"
        }
    }
}

export const EXPORT_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "playbackRates": [0.25, 0.5, 1, 1.5, 2],
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }, "exportOptions": {"title": "Teasing empreinte.com", "url": "", "embedCode": ""}
    }
}


export const TV_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": false,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}


export const COMMENTS_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }, "commentsOptions": true
    }
}


export const QUESTION_AND_QUIZ_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "videoId" : 94,
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }, "surveyOptions": true
    }
}

export const SEARCH_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }, "searchOptions": false
    }
}

export const NAVIGATION_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }
    }
}

export const MAIL_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        },
        "shareOptions": {
            "socials": ["fb", "tw", "linkedin", "mail"],
            "title": "Teasing empreinte.com",
            "description": "",
            "image": "https:\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
            "fbAppId": "1980855782163905",
            "hashtag": "#Teasing_empreinte.com"
        }, "sendMailOptions": true
    }
}


export const HOTKEY_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        }, "hotKeyOptions": true
    }
}


export const INTERACTIVITY_OPTIONS = {
    "data": {
        "client": "demo",
        "colorOptions": "250,149,43",
        "playerOptions": {
            "autoplay": false,
            "loop": true,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "controlBarOptions": true,
            "flash": {"hls": {"withCredentials": false}},
            "html5": {"hls": {"withCredentials": false}},
            "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": "\/\/vodempreinte-vh.akamaihd.net\/i\/demoV4\/mp4\/empreinte-motion-vf-61a5gyue-43_94_,850,450,250,.mp4.csmil\/master.m3u8",
                "selected": true
            }],
            "textTracks": [],
            "poster": "\/\/demo-fo.webtv-solution.com\/web\/data\/vignettes\/cf1755458d37033d81799d089971d4dd.jpg",
        },
        "interactivityOptions": {
            "video": {"id": 94},
            "data": {
                "interactivity": [{
                    "start": 1,
                    "number": 0,
                    "title": "chapitre 1 ",
                    "type": "chapter",
                    "theme": "element_off"
                }, {
                    "start": 3,
                    "number": 0,
                    "title": "chapitre 3 ",
                    "type": "chapter",
                    "theme": "element_off"
                }, {
                    "start": 5,
                    "title": "quiz 1 ",
                    "type": "quiz",
                    "choices": [{"choice": "reponse 1"}],
                    "theme": "element_off"
                }],
                "slides": [{
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 1,
                    "type": "image",
                    "number": 1,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 3,
                    "type": "image",
                    "number": 2,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 5,
                    "type": "image",
                    "number": 3,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec27de3dd38.jpg",
                    "start": 7,
                    "type": "image",
                    "number": 4,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec27de3dd38.jpg",
                        "theme": "element_off"
                    }
                }, {
                    "name": "img_5aec29bd393ea.jpg",
                    "start": 13,
                    "type": "image",
                    "number": 6,
                    "loop": false,
                    "content": {
                        "type": "image",
                        "src": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec29bd393ea.jpg",
                        "thumbnail": "http:\/\/demo-fo.webtv-solution.com\/web\/data\/slides\/95\/img_5aec29bd393ea.jpg",
                        "theme": "element_off"
                    }
                }]
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/video/loop.js